import { Action, on } from '@ngrx/store';

import {
  emptyState,
  errorState,
  isLoadingState,
  isResultState,
  loadingState,
  resultState,
} from '../../../@core/fetch-state.utils';
import { AppState } from '../../app.state.interface';

import { ItemProcessesActions } from './item-processes.actions';
import { ItemProcessGroup } from './item-processes.service';
import { ItemProcesessState } from './item-processes.state';

export const itemProcessesStateFactory: ItemProcesessState = {
  groups: emptyState(),
  categories: emptyState(),
};

// Helper to update a single group in the state
const updateSingleGroup = (state: AppState, group: ItemProcessGroup | null): AppState => {
  if (!group || !isResultState(state.groups)) {
    // If no updated group or original groups aren't loaded, do nothing
    return state;
  }
  const updatedGroups = state.groups.data.map((existingGroup: ItemProcessGroup) =>
    existingGroup.categoryKey === group.categoryKey ? group : existingGroup,
  );
  return {
    ...state,
    groups: resultState(updatedGroups),
  };
};

export const itemProcessesReducers = [
  // Load Item Processes
  on(ItemProcessesActions.loadItemProcesses, (state: AppState) => ({
    ...state,
    groups: loadingState(),
  })),
  on(ItemProcessesActions.loadItemProcessesSuccess, (state: AppState, { groups }) => ({
    ...state,
    groups: resultState(groups),
  })),
  on(ItemProcessesActions.loadItemProcessesFailure, (state: AppState, { error }) => ({
    ...state,
    groups: errorState([error]),
  })),

  // Load Item Group Page
  on(ItemProcessesActions.loadItemGroupPage, (state: AppState) => ({
    ...state,
    // Optionally indicate loading for the specific group
  })),
  on(
    ItemProcessesActions.loadItemGroupPageSuccess,
    (state: AppState, { group }): AppState => updateSingleGroup(state, group),
  ),
  on(ItemProcessesActions.loadItemGroupPageFailure, (state: AppState, { error }) => ({
    ...state,
    // Handle error
    groups: state.groups,
  })),

  // Sort Item Group
  on(ItemProcessesActions.sortItemGroup, (state: AppState) => ({
    ...state,
    // Optionally indicate loading for the specific group being sorted
  })),
  on(
    ItemProcessesActions.sortItemGroupSuccess,
    (state: AppState, { group }): AppState => updateSingleGroup(state, group),
  ),
  on(ItemProcessesActions.sortItemGroupFailure, (state: AppState, { error }) => ({
    ...state,
    // Handle error
    groups: state.groups,
  })),

  // Load Item Process Categories
  on(ItemProcessesActions.loadItemProcessCategories, (state: AppState) => ({
    ...state,
    categories: loadingState(),
  })),
  on(ItemProcessesActions.loadItemProcessCategoriesSuccess, (state: AppState, { categories }) => ({
    ...state,
    categories: resultState(categories),
  })),
  on(ItemProcessesActions.loadItemProcessCategoriesFailure, (state: AppState, { error }) => ({
    ...state,
    categories: errorState([error]),
  })),

  on(ItemProcessesActions.loadOnlyItemProcessCategoriesSuccess, (state: AppState, { categories }) => ({
    ...state,
    categories: resultState(categories),
  })),
  on(ItemProcessesActions.loadOnlyItemProcessCategoriesFailure, (state: AppState, { error }) => ({
    ...state,
    categories: errorState([error]),
  })),
];
